// extracted by mini-css-extract-plugin
module.exports = {"subtotal":"styles_subtotal__ICYuO","title":"styles_title__L_pPG","amount":"styles_amount__tVjCq","previousAmount":"styles_previousAmount__hM4wk"};